import * as ActionTypes from '../constants/ActionTypes'
import { getRequest, postRequest_ } from './http'
import { baseurl } from '../constants/constants';

export function setData(items, name) {
    return {
        type: ActionTypes.SET_DATA,
        name: name,
        items: items
    }
}

export function setDataConcat(items, name) {
    return {
        type: ActionTypes.DATA_WITH_PAGINATION_CONCAT,
        name: name,
        items: items
    }
}

const get_ = (data, controller) => {
    return (dispatch) => {
        //dispatch(loading());
        console.log(data.typeOption);
        getRequest(data, controller).then(
            (response) => {
                if (data.typeOption == "get_data_products_backup") {
                    dispatch(setData({
                        all_products_server: response.data,
                        loading: false,
                        response: {
                            Msg: "Productos encontrados",
                            redirect: false,
                            success: 1,
                            action: data.typeOption
                        },
                        simpleToast: false
                    }));
                } else if (data.typeOption == "get_data_contacts_backup") {
                    dispatch(setData({
                        all_contacts_server: response.data,
                        loading: false,
                        response: {
                            Msg: "Clientes encontrados",
                            redirect: false,
                            success: 1,
                            action: data.typeOption
                        },
                        simpleToast: false
                    }));
                }


            },
            (err) => {
            }
        );
    }
};

const post_ = (data, controller) => {
    return (dispatch) => {
        postRequest_(data, controller).then(
            (response) => {

            },
            (err) => {

            }
        );
    }
};

export default {
    get_,
    post_,
    setData
}
